import type { LocaleDictionary } from "@/i18n/types";

const nsOrgEN = {
  list: {
    title: "My Organizations",
    invitedTitle: "Pending Invitations",
  },
  tab: {
    joined: "Active Organizations",
    invited: "Pending Invitations",
  },
  table: {
    header: {
      name: "Organization",
      shortName: "Short Name",
      kind: "Type",
      memberCount: "Members",
      description: "Description",
      mfa: "Two-Factor Auth",
      action: "Actions",
      isOwner: "Owner Role",
    },
    mfa: {
      required: "Required",
      optional: "Optional",
      notConfiguredAlert: "2FA is not enabled.",
    },
    defaultOrgChangeError: "Failed to set default organization.",
  },
  invitation: {
    acceptButton: "Accept",
    rejectButton: "Decline",
    accept: {
      errorMessage: "Failed to accept the invitation",
    },
    reject: {
      confirmTitle: "Decline Organization Invitation",
      confirmMessage: "Decline the invitation to this organization?",
      confirmMessageWithName: ({
        organizationName,
      }: {
        organizationName: string;
      }) => `Decline the invitation to ${organizationName}?`,
      confirmButton: "Decline",
      inProgressTitle: "Declining invitation...",
      successMessage: "Invitation declined.",
      errorMessage: "Failed to decline the invitation.",
    },
    mfaRequired: {
      title: "Two-Factor Authentication Required",
      description:
        "This organization requires two-factor authentication for security reasons. Please enable it in your account settings and try accepting the invitation again.",
      stepsTitle: "Instructions",
      step1: "Open Account Settings",
      step2: 'Enable two-factor authentication and click "Change"',
      step3: 'Log in again, return to this screen, and click "Accept"',
      guideLink: "View Setup Guide",
      accountSettingButton: "Go to Account Settings",
      closeButton: "Close",
    },
  },
  menu: {
    ariaLabel: "Organization Menu",
    switchButton: "Switch Organization",
    pendingInvitations: ({ count }: { count: number }) =>
      `${count} pending organization invitation(s)`,
    organizationGroup: "Organization",
    addonGroup: "Add-ons",
    setting: "Organization Settings",
    settingItem: {
      organizationInfo: "Organization Info",
      functions: "Features",
      members: "Members",
      categories: "Categories",
      roles: "Roles & Permissions",
      notifications: "Notifications",
      cliApiKeys: "CLI API Keys",
    },
  },
  switchDialog: {
    title: "Switch Organization",
    description: "Switch to another organization.",
    noOrganizations: "No organizations found.",
    underMaintenance: "This organization is under maintenance.",
    cancelButton: "Cancel",
  },
  infoDialog: {
    title: "Organization Info",
    name: "Organization Name",
    id: "Organization ID",
    description: "Description",
    memberCount: "Members",
    closeButton: "Close",
  },
} satisfies LocaleDictionary;

export default nsOrgEN;
